var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClase41(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "716.684px",
    height: "715.904px",
    viewBox: "0 0 716.684 715.904",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.175,358.104c8.055,8.055,350.061,350.061,358.115,358.111c8.055-8.053,350.068-350.059,358.123-358.111 C709.359,350.05,367.345,8.052,359.291,0C351.236,8.052,9.23,350.05,1.175,358.104z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_copy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M226.496,132.79v450.635c19.333,19.332,37.896,37.895,54.699,54.698V78.092 C264.392,94.895,245.829,113.458,226.496,132.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M359.291,0c-1.311,1.31-11.469,11.468-27.585,27.583v661.049c16.116,16.117,26.274,26.273,27.585,27.584 c1.298-1.297,11.273-11.272,27.114-27.113V27.112C370.564,11.272,360.588,1.297,359.291,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M435.519,76.224V639.99c16.531-16.53,34.822-34.821,53.921-53.919v-455.93 C470.341,111.043,452.05,92.754,435.519,76.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M540.402,181.101V535.11c19.031-19.031,38.029-38.027,56.14-56.139V237.238 C578.431,219.127,559.433,200.131,540.402,181.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M647.857,288.551v139.107c39.379-39.377,67.322-67.319,69.557-69.554 C715.179,355.87,687.236,327.928,647.857,288.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M1.175,358.104c2.288,2.288,31.526,31.525,72.395,72.395V285.712 C32.701,326.58,3.463,355.816,1.175,358.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M124.969,234.314v247.583c16.967,16.967,34.665,34.664,52.402,52.402V181.913 C159.633,199.65,141.936,217.347,124.969,234.314z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Normal"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.785,185.188 420.72,192.938 411.41,198.063 417.095,184.875 417.16,165 414.834,151.016 406.66,134.313  404.846,153.813 400.167,167.777 396.16,173.938 390.471,176 392.41,163.625 390.595,151.75 386.405,142.528 380.285,129.063  369.846,106.188 363.285,84.75 358.825,97.282 356.868,107.491 356.787,130.682 356.493,148.668 354.118,159.782 348.637,171.5  343.221,160.633 340.829,147.797 337.348,138.663 332.471,133.75 331.706,133.508 320.887,130.084 323.553,140.834  321.137,154.418 319.553,166.834 319.637,178.811 323.303,189.834 316.804,184.918 309.637,178.084 304.804,168.834  296.471,160.584 298.804,180.584 299.054,192.334 301.357,207.996 304.804,217.668 310.971,229.25 296.054,227.25 288.971,221.418  282.721,213.168 281.195,211.588 275.637,205.834 278.221,220.25 281.195,230.935 290.887,265.75 299.351,277.887 314.221,290.168  331.706,295.167 335.123,296.145 349.734,297.443 365.485,297.932 349.734,295.01 338.387,289.418 331.706,282.736  326.887,277.918 318.889,257.996 326.357,263.516 331.706,264.951 333.752,265.5 348.441,267.063 342.352,258.092 336.746,253.125  335.123,243.549 334.955,226.111 338.045,234.943 342.754,241.275 349.246,245.659 357.202,248.579 355.311,236.295  355.154,227.268 359.519,215.225 363.228,204.361 363.364,187.193 372.083,195.957 379.591,207.67 383.524,225.774  383.437,249.428 386.405,247.103 387.971,245.875 395.785,240.938 402.72,234.313 406.471,224.375 406.535,241.688 401.971,255  397.66,260.813 390.846,267.188 400.548,267.412 409.535,264.813 418.346,261.188 408.971,278.375 399.72,286.563 387.41,295.75  386.405,296.19 381.846,298.188 386.405,298.188 395.285,298.188 407.535,295.625 421.471,288.438 431.971,281 435.519,275.286  442.095,264.688 448.346,243.313 450.346,214.813 446.329,226.178 438.374,232.346 435.519,233.104 425.535,235.75 433.66,223.625  435.519,219.827 437.971,214.813 442.16,198 439.91,185.813 435.66,171.875 435.519,172.105 432.66,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.706,311.897 296.925,311.897 296.925,327.068 331.706,327.068 386.405,327.068 435.519,327.068  438.223,327.068 438.223,311.897 435.519,311.897 386.405,311.897  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.315,580.544V544.36h-14.661l-22.73,36.226v9.063h25.72v13.718h11.671v-13.718h7.311v-9.105H377.315z M365.644,580.544 h-16.339l16.339-25.021V580.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.857,327.511l-51.315-51.317l-56.14-56.138l-50.962-50.961l-53.921-53.922L386.405,66.06l-27.114-27.113 l-27.585,27.585l-50.51,50.511l-54.699,54.699l-49.125,49.126l-52.402,52.402L73.57,324.67l-29.999,29.998l29.999,29.999 l51.398,51.398l52.402,52.402l49.125,49.126l54.699,54.7l50.51,50.51l27.588,27.59l27.111-27.111l49.114-49.113l53.921-53.922 l50.962-50.963l56.14-56.139l51.315-51.314l27.16-27.16L647.857,327.511z M596.542,419.753l-56.14,56.139l-50.962,50.963 l-53.921,53.922l-49.114,49.113L359.293,657l-27.588-27.589l-50.51-50.51l-54.699-54.699l-49.125-49.127l-52.402-52.402 L73.57,371.274l-16.605-16.606l16.605-16.605l51.398-51.398l52.402-52.402l49.125-49.125l54.699-54.699l50.51-50.511l27.585-27.585 l27.114,27.113l49.114,49.113l53.921,53.92l50.962,50.962l56.14,56.139l51.315,51.314l13.769,13.769l-13.769,13.768 L596.542,419.753z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.405,32.226 402.875,48.698 408.989,42.584 376.669,10.262 373.111,13.819 370.555,16.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.716,97.423 460.272,93.867 427.951,61.545 421.835,67.659 435.519,81.339 454.16,99.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.44,135.261 505.441,151.262 511.555,145.149 479.233,112.828 475.675,116.385 473.119,118.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.282,199.988 562.838,196.432 530.516,164.109 524.402,170.223 540.402,186.223 556.724,202.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "596.542,242.362 608.006,253.827 614.119,247.713 581.797,215.393 578.242,218.948 575.684,221.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.846,302.551 665.401,298.996 633.081,266.674 626.967,272.787 647.857,293.679 659.287,305.109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.361,317.957 680.807,321.512 678.248,324.07 710.57,356.391 713.128,353.833 716.684,350.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.114,353.223 4.647,354.688 0,359.336 32.32,391.659 36.969,387.011 38.435,385.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.93,405.972 51.282,410.619 83.603,442.94 89.717,436.827 73.57,420.681 57.395,404.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.969,472.079 108.678,455.787 102.565,461.901 134.886,494.223 139.534,489.575 141,488.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.494,508.536 153.847,513.185 186.169,545.506 192.283,539.394 177.371,524.481 159.961,507.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.496,573.606 211.244,558.354 205.129,564.468 237.451,596.789 242.098,592.142 243.565,590.674  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.058,611.103 256.412,615.748 288.732,648.07 294.847,641.957 281.195,628.306 262.525,609.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.706,678.815 313.807,660.919 307.693,667.031 340.016,699.354 344.662,694.706 346.129,693.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.28,317.053 46.26,313.034 44.166,310.939 11.845,343.262 13.939,345.355 17.959,349.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.57,293.764 101.563,265.771 95.449,259.656 63.128,291.979 65.222,294.072 69.242,298.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.825,210.468 146.731,208.375 114.41,240.695 120.523,246.811 124.969,242.366 152.846,214.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.371,189.963 204.128,163.205 198.014,157.092 165.693,189.412 167.786,191.506 171.806,195.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.39,107.902 249.297,105.809 216.974,138.131 223.089,144.244 226.496,140.837 255.41,111.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.195,86.139 306.691,60.643 300.578,54.527 268.257,86.85 270.35,88.942 274.371,92.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.953,5.338 351.86,3.247 319.539,35.566 325.653,41.68 331.706,35.627 357.975,9.359  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.682,
    y: 692.365,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -381.4816 472.4736)",
    width: 45.709,
    height: 8.644
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.965,
    y: 641.081,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -330.194 493.7158)",
    width: 45.709,
    height: 8.644
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.247,
    y: 589.797,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -278.9038 514.9346)",
    width: 45.712,
    height: 8.645
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.531,
    y: 538.514,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -227.619 536.1205)",
    width: 45.711,
    height: 8.649
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.814,
    y: 487.233,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -176.3353 557.4196)",
    width: 45.709,
    height: 8.646
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.096,
    y: 435.951,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -125.0562 578.6376)",
    width: 45.706,
    height: 8.647
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.378,
    y: 384.669,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -73.7634 599.9142)",
    width: 45.709,
    height: 8.645
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.496,
    y: 29.479,
    display: "inline",
    fill: "#99FFFF",
    width: 54.699,
    height: 667.207
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.706,
    y: -31.708,
    display: "inline",
    fill: "#99FFFF",
    width: 54.699,
    height: 857.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.519,
    y: 52.339,
    display: "inline",
    fill: "#99FFFF",
    width: 53.921,
    height: 656.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.402,
    y: 144.245,
    display: "inline",
    fill: "#99FFFF",
    width: 56.14,
    height: 481.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.857,
    y: 260.284,
    display: "inline",
    fill: "#99FFFF",
    width: 93.385,
    height: 206.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24.758,
    y: 253.298,
    display: "inline",
    fill: "#99FFFF",
    width: 98.328,
    height: 217
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.969,
    y: 157.089,
    display: "inline",
    fill: "#99FFFF",
    width: 52.402,
    height: 410.944
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClase41);
export default __webpack_public_path__ + "static/media/clase4-1.754e7555736bb85ca963ef59fe1457d2.svg";
export { ForwardRef as ReactComponent };